<div class="row row-cards">
    <div class="col-sm-12">
        <h2>Total Case's for {{todayDate}} Till - {{currentTime}}</h2>
    </div>

    <div class="card">
        <div class="table-responsive">
            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                <thead>
                    <tr>
                        <th style="width: 3%;">#</th>
                        <th>Category</th>
                        <th>Total Admission</th>
                        <th>Total Admission Done</th>
                        <th>Total OT</th>
                        <th>Total OT Done</th>
                        <th>Total Discharges</th>
                        <th>Total Discharges Done</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" *ngFor="let ipds of IpdData let index = index;" >
                        <td style="width: 3%;">{{index+1}}</td>
                        <td>{{ipds.circle_name}}</td>
                        <td>{{ipds.today_total_arrival}}</td>
                        <td>{{ipds.today_actual_admit}}</td>
                        <td>{{ipds.today_total_surgery}}</td>
                        <td>{{ipds.today_actual_ot}}</td>
                        <td>{{ipds.today_total_discharge}}</td>
                        <td>{{ipds.today_actual_discharge}}</td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="8" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr class="text-center" >
                        <td style="width: 3%;">&nbsp;</td>
                        <td><b>Total</b></td>
                        <td><b>{{total_admission}}</b></td>
                        <td><b>{{total_admission_done}}</b></td>
                        <td><b>{{total_ot}}</b></td>
                        <td><b>{{total_ot_done}}</b></td>
                        <td><b>{{total_discharges}}</b></td>
                        <td><b>{{total_discharges_done}}</b></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
